export const lock = () => jQuery(document.documentElement).addClass("no-scroll");

export const unlock = () => jQuery(document.documentElement).removeClass("no-scroll");
